module.exports = __webpack_public_path__ + "img/cancelPay.4dbb164f.jpg";